<!--
 * @Description: 异常处理
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-05-21 09:08:46
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <!-- <div class="tabtop">
          <div v-for="(item, index) in contractTypelist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index ? 'active' : 'text'">{{ item.value }}</div>
          </div>
        </div> -->
        <div class="search">
          <span style="display: inline-block; margin-bottom: 10px">
            <span style="margin-right: 12px">异常类型</span>
            <el-select v-model="tableParam.exceptionType" placeholder="请选择" clearable>
              <el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </span>
          <span style="display: inline-block; margin-bottom: 10px">
            <span style="margin-right: 12px">车牌号</span>
            <el-input v-model="tableParam.carNo" style="width: 220px" placeholder="请输入" clearable />
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">状态</span>
            <el-select v-model="tableParam.handlerStatus" placeholder="请选择" clearable>
              <el-option :key="1" label="待处理" :value="1"> </el-option>
              <el-option :key="2" label="已处理" :value="2"> </el-option>
            </el-select>
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">站点</span>
            <el-select v-model="tableParam.stationId" style="width: 7rem" placeholder="请选择" clearable>
              <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </span>
          <span style="display: inline-block; margin-bottom: 10px">
            <span style="margin-right: 12px">异常描述</span>
            <el-input v-model="tableParam.excepDescription" style="width: 220px" placeholder="请输入" clearable />
          </span>
          <el-button style="margin-left: 12px" icon="el-icon-search" size="medium" class="bottom_all"
            @click="(tableParam.page = 1), gettableData()">查 询</el-button>
          <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
        </div>
        <div style="margin: 10px 0px"></div>
        <div class="card">
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="item.label == '图片'">
                      <el-button v-if="scope.row.exceptionType == 1 ||
                        scope.row.exceptionType == 2 ||
                        scope.row.exceptionType == 4 ||
                        scope.row.exceptionType == 5 ||
                        scope.row.exceptionType == 6 ||
                        scope.row.exceptionType == 7 ||
                        scope.row.exceptionType == 8
                        " size="mini" class="bottom_one" @click="look1Fun(scope.row)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '异常详情'">
                      <el-button size="mini" class="bottom_one" @click="lookExceptionDetail(scope.row)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '状态'">
                      <span v-if="scope.row.handlerStatus == 1">待处理</span>
                      <span v-if="scope.row.handlerStatus == 2">已处理</span>
                    </div>
                    <div v-else-if="item.label == '异常类型'">
                      <span>{{ exceptionTypeList.find(item => item.value == scope.row.exceptionType * 1).name }}</span>
                    </div>
                    <div v-else-if="item.label == '处理'">
                      <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANXIE') !== -1" size="mini"
                        class="bottom_one" @click="look2Fun(scope.row)">{{ scope.row.handlerStatus == 1 ? "填写" : "查看"
                        }}</el-button>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="look1Type" width="740px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">图片/视频信息预览</span>
      <div class="dialoginfo">
        <div class="FZYimgMp4list">
          <div v-for="(v, k) in urlList" :key="k">
            <el-image v-if="$options.filters.imgMp4TypeFun(v) == 'img'" :src="'/file/' + v" :preview-src-list="srcList"
              style="width: 200px; height: 200px; margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)"
              :z-index="10000" @click="srcList = ['/file/' + v]"></el-image>
            <video v-else width="200" height="200" style="margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)"
              :src="'/file/' + v" controls>您的浏览器不支持 HTML5 video 标签。</video>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look1Type = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="860px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">异常处理办法</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :rules="rules" :model="formData" label-width="140px">
          <!-- 司机离场泵送异常 -->
          <div v-if="low.exceptionType == 7">
            <el-row>
              <el-col :span="12">
                <el-form-item label="工程名称:">
                  <span>{{ formData.engineeringName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运输号:">
                  <span>{{ formData.logisticsCode }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌号:">
                  <span>{{ formData.carNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="浇筑部位:">
                  <span>{{ formData.structuralParts }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="离场浇筑方式:">
                  <span>{{ formData.pouringMethodName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="泵送方式:">
                  <span>{{ formData.departurePouringMethod }}</span>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否继续产生异常:">
                  <el-radio-group v-model="formData.isFlag">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计划浇筑方式:">
                  <span>{{ formData.planPourMethodName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="浇筑方式:">
                  <el-select v-model="formData.pouringMethodIds" multiple placeholder="请选择" style="width: 220px"
                    :disabled="low.handlerStatus == 2" @change="$forceUpdate()">
                    <el-option v-for="item in pumpTypeList" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="浇筑量:">
                  <span>{{ formData.faceValue }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="泵机编号:" prop="pumpNo">
                  <el-input v-model="formData.pumpNo" :disabled="low.handlerStatus == 2" style="width: 220px"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
          </div>
          <!-- 司机回场未及时过磅异常 -->
          <div v-if="low.exceptionType == 9">
            <el-row>
              <el-col :span="12">
                <el-form-item label="工程名称:">
                  <span>{{ formData.engineeringName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运输号:">
                  <span>{{ formData.logisticsCode }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌号:">
                  <span>{{ formData.carNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="浇筑部位:">
                  <span>{{ formData.structuralParts }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="产品名称:">
                  <span>{{ formData.productName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="票面量:">
                  <span>{{ formData.faceValue }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="余料量:" prop="exceptionResidueNum">
                  <el-input v-model="formData.exceptionResidueNum" type="number" :disabled="low.handlerStatus == 2"
                    style="width: 220px"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 司机过磅数据异常 -->
          <div v-if="low.exceptionType == 8">
            <el-row>
              <el-col :span="12">
                <el-form-item label="工地重车过磅量:" prop="reconditionSiteNum">
                  <el-input v-model="formData.reconditionSiteNum" type="Number" :disabled="low.handlerStatus == 2"
                    style="width: 220px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工地空车过磅量:" prop="emptySiteNum">
                  <el-input v-model="formData.emptySiteNum" type="Number" :disabled="low.handlerStatus == 2"
                    style="width: 220px"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="low.handlerStatus == 1">
              <el-col :span="12">
                <el-form-item>
                  <span slot="label">工地重车过磅照片<el-tooltip effect="dark" content="（可拍摄过磅单、过磅显示屏等含客户过磅数据的照片）"
                      placement="top-end"> <i class="el-icon-warning-outline delete-icon"></i> </el-tooltip></span>
                  <FileComponent fileCode="exceptionHandling2" :files="listFiles2" @deleteFile="deleteFile2"
                    @uplodeSuccess="uplodeSuccess2" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <span slot="label">工地空车过磅照片<el-tooltip effect="dark" content="（可拍摄过磅单、过磅显示屏等含客户过磅数据的照片）"
                      placement="top-end"> <i class="el-icon-warning-outline delete-icon"></i> </el-tooltip></span>
                  <FileComponent fileCode="exceptionHandling2" :files="listFiles3" @deleteFile="deleteFile3"
                    @uplodeSuccess="uplodeSuccess3" />
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="low.handlerStatus == 2">
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <span slot="label">工地重车过磅照片<el-tooltip effect="dark" content="（可拍摄过磅单、过磅显示屏等含客户过磅数据的照片）"
                        placement="top-end"> <i class="el-icon-warning-outline delete-icon"></i> </el-tooltip></span>
                    <div class="FZYimgMp4list">
                      <div v-for="(v, k) in listFiles2" :key="k">
                        <el-image :src="'/file/' + v" :preview-src-list="srcList"
                          style="width: 200px; height: 200px; margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)"
                          :z-index="10000" @click="srcList = ['/file/' + v]"></el-image>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <span slot="label">工地空车过磅照片<el-tooltip effect="dark" content="（可拍摄过磅单、过磅显示屏等含客户过磅数据的照片）"
                        placement="top-end"> <i class="el-icon-warning-outline delete-icon"></i> </el-tooltip></span>
                    <div class="FZYimgMp4list">
                      <div v-for="(v, k) in listFiles3" :key="k">
                        <el-image :src="'/file/' + v" :preview-src-list="srcList"
                          style="width: 200px; height: 200px; margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)"
                          :z-index="10000" @click="srcList = ['/file/' + v]"></el-image>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="异常原因:" prop="exceptionReasonId">
                  <el-select ref="exceptionReasonId" v-model="formData.exceptionReasonId" placeholder="请选择"
                    :disabled="low.handlerStatus == 2" style="width: 220px" @change="
                      $nextTick(() => {
                        formData.exceptionReason = $refs.exceptionReasonId.selectedLabel;
                      })
                      ">
                    <el-option v-for="item in exceptionReasonList" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否继续产生异常:">
                  <el-radio-group v-model="formData.isFlag">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 客户拒绝签收异常 -->
          <div v-if="low.exceptionType == 10">
            <el-row>
              <el-col :span="12">
                <el-form-item label="拒绝类型:">
                  <span>{{ formData.refuseType }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="认可的签收量:">
                  <span>{{ formData.acceptSignNum }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="拒绝原因:">
                  <span>{{ formData.exceptionReason }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="票面量:">
                  <span>{{ formData.faceValue }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="原始客户余料量:">
                  <span>{{ Number(formData.faceValue - formData.oldSignNum) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="原始客户签收量:">
                  <span>{{ formData.oldSignNum }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="调整客户余料量:">
                  <span>{{ Number(formData.faceValue - (formData.adjustSignNum || 0)) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="调整客户签收量:" prop="adjustSignNum">
                  <el-input v-model="formData.adjustSignNum" type="number" :disabled="low.handlerStatus == 2"
                    style="width: 220px"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 图算超量异常 -->
          <div v-if="low.exceptionType == 3">
            <el-row>
              <el-col :span="12">
                <el-form-item label="异常原因:" prop="exceptionReasonId">
                  <el-select ref="exceptionReasonId" v-model="formData.exceptionReasonId" placeholder="请选择"
                    :disabled="low.handlerStatus == 2" style="width: 220px" @change="
                      $nextTick(() => {
                        formData.exceptionReason = $refs.exceptionReasonId.selectedLabel;
                      })
                      ">
                    <el-option v-for="item in exceptionReasonList" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="24">
              <el-form-item label="填写处理办法:" prop="handlerMethod">
                <el-input v-model="formData.handlerMethod" :rows="5" resize="none" style="width: 580px" type="textarea"
                  placeholder="请详细描述异常处理办法" :disabled="low.handlerStatus == 2" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="low.exceptionType != 8">
            <el-col :span="24">
              <el-form-item>
                <span slot="label">照片/视频:</span>
                <FileComponent v-if="low.handlerStatus == 1" fileCode="exceptionHandling1" :files="listFiles1"
                  @deleteFile="deleteFile1" @uplodeSuccess="uplodeSuccess1" />
                <div v-else class="FZYimgMp4list">
                  <div v-for="(v, k) in listFiles1" :key="k">
                    <el-image v-if="$options.filters.imgMp4TypeFun(v) == 'img'" :src="'/file/' + v"
                      :preview-src-list="srcList"
                      style="width: 200px; height: 200px; margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)"
                      :z-index="10000" @click="srcList = ['/file/' + v]"></el-image>
                    <video v-else width="200" height="200"
                      style="margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)" :src="'/file/' + v"
                      controls>您的浏览器不支持 HTML5 video 标签。</video>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialog = false">取 消</el-button>
        <el-button v-if="low.handlerStatus != 2" class="bottom_all" style="margin-left: 24px" @click="submit()">确
          定</el-button>
      </span>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog :visible.sync="exceptionDetailDig" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">异常详情</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="exceptionDetailData" tooltip-effect="dark">
          <template v-for="(item, index2) in exceptionDetailTable">
            <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="item.label == '计划浇筑方式'">
                  <span v-for="(item, index) in scope.row.pouringMethod" :key="index">{{ item.name }}</span>
                </div>
                <!-- <div v-else-if="item.label == '离场浇筑方式'">
                  <span v-for="(item, index) in scope.row.outPouringMethod" :key="index">{{ item.name }}</span>
                </div> -->
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exceptionDetailDig = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
import {
  queryPage,
  // attachment_list,
  handler_info,
  save_handler,
  getBusinessDetail,
} from "@/api/smart/schedul/g.js";
import { getUserAutList, getDicType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth";
export default {
  components: { FileComponent },
  mixins: [mixin],
  data() {
    return {
      UserInfo:{},
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      /*表格数据*/
      table: [],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      contractTypelist: [
        { value: "前场作业异常", id: 0 },
        { value: "罐车运输异常", id: 1 },
      ],
      currenindex: 0,
      tableA: [
        { label: "异常类型", width: "auto", prop: "exceptionType", status: true },
        {
          label: "异常描述",
          width: "120",
          prop: "excepDescription",
          status: true,
        },
        {
          label: "车牌号",
          width: "120",
          prop: "carNo",
          status: true,
        },
        {
          label: "站点",
          width: "120",
          prop: "station",
          status: true,
        },
        {
          label: "图片",
          width: "auto",
          prop: "",
          status: true,
        },
        {
          label: "异常原因",
          width: "auto",
          prop: "excepReason",
          status: true,
        },
        {
          label: "异常详情",
          width: "auto",
          prop: "",
          status: true,
        },
        {
          label: "提交人",
          width: "100",
          prop: "createUserName",
          status: true,
        },
        {
          label: "联系电话",
          width: "120",
          prop: "phoneNum",
          status: true,
        },
        {
          label: "提交时间",
          width: "auto",
          prop: "createTime",
          status: true,
        },
        {
          label: "状态",
          width: "auto",
          prop: "handlerStatus",
          status: true,
        },
        {
          label: "处理人",
          width: "100",
          prop: "field1",
          status: true,
        },
        { label: "处理", width: "auto", prop: "", status: true },
      ],
      tableB: [
        { label: "车牌号", prop: "carNo", status: true },
        { label: "异常类型", prop: "typeName", status: true },
        {
          label: "异常描述",
          prop: "excepDescription",
          status: true,
        },
        {
          label: "附件信息",
          prop: "",
          status: true,
        },
        {
          label: "提交人",
          prop: "createUserName",
          status: true,
        },
        {
          label: "联系电话",
          prop: "phoneNum",
          status: true,
        },
        {
          label: "提交时间",
          width: "auto",
          prop: "createTime",
          status: true,
        },
        {
          label: "状态",
          prop: "handlerStatus",
          status: true,
        },
        { label: "处理", prop: "", status: true },
      ],
      fromDate: {},
      addDialog: false,
      look1Type: false,
      urlList: [],
      formData: {
        businessExceptionId: "", // 异常id
        handlerMethod: "", // 异常处理方式
        handlerImageUrl: "", // 异常处理图片地址
        engineeringName: "", // 工程名称
        engineeringId: "", //  工程id
        logisticsCode: "", //  物流编号
        carNo: "", //  车牌号
        structuralParts: "", //    浇筑部位
        pouringNum: "", //  浇筑量
        pouringMethod: "", // 浇筑方式
        pouringMethodIds: [],
        pumpNo: "", //  泵机编号
        reconditionSiteNum: "", //   重车过磅量
        emptySiteNum: "", // 空车过磅量
        reconditionUrl: "", //  重车过磅图片
        emptyUrl: "", // 空车过磅图片
        refuseTypeId: "", //  拒绝类型id
        refuseType: "", //  拒绝类型
        acceptSignNum: "", //  认可接收量
        oldSignNum: "", //  原接收量
        adjustSignNum: "", // 调整签收量
        exceptionReasonId: "", //  异常原因id
        exceptionReason: "", //   异常原因
        isFlag: 1, //   是否继续产生异常
      },
      srcList: [],
      exceptionTypeList: [
        {
          name: "前场异常",
          value: 1,
        },
        {
          name: "运输异常",
          value: 2,
        },
        {
          name: "图算超量异常",
          value: 3,
        },
        {
          name: "泵工扫泵异常",
          value: 4,
        },
        // {
        //   name: "客户地磅异常",
        //   value: 5,
        // },
        // {
        //   name: "司机扫泵异常",
        //   value: 6,
        // },
        {
          name: "司机泵送异常",
          value: 7,
        },
        {
          name: "工地过磅异常",
          value: 8,
        },
        {
          name: "司机回场未及时过磅异常",
          value: 9,
        },
        {
          name: "客户拒绝签收异常",
          value: 10,
        },
      ],
      listFiles1: [],
      listFiles2: [],
      listFiles3: [],
      pumpTypeList: [], //浇筑方式泵机类型
      exceptionReasonList: [],
      low: {},
      rules: {
        pumpNo: [{ required: true, message: "请输入泵机编号", trigger: "blur" }],
        reconditionSiteNum: [{ required: true, message: "请输入工地重车过磅量", trigger: "blur" }],
        emptySiteNum: [{ required: true, message: "请输入工地空车过磅量", trigger: "blur" }],
        exceptionReasonId: [{ required: true, message: "请选择异常原因", trigger: "change" }],
        adjustSignNum: [{ required: true, message: "请输入调整客户签收量", trigger: "blur" }],
        handlerMethod: [{ required: true, message: "请输入异常处理办法", trigger: "blur" }],
        exceptionResidueNum: [{ required: true, message: "请输入余料量", trigger: "blur" }],
      },
      exceptionDetailDig: false,
      exceptionDetailTable: [
        {
          label: "订单号",
          width: "120",
          prop: "orderNo",
          status: true,
        },
        {
          label: "运输号",
          width: "120",
          prop: "logCode",
          status: true,
        },
        {
          label: "工程名称",
          width: "120",
          prop: "engineeringName",
          status: true,
        },
        {
          label: "图算量",
          width: "120",
          prop: "graphicNum",
          status: true,
        },
        {
          label: "已浇筑量",
          width: "120",
          prop: "pouringNum",
          status: true,
        },
        {
          label: "票面量",
          width: "120",
          prop: "faceValue",
          status: true,
        },
        {
          label: "车牌号",
          width: "120",
          prop: "carNo",
          status: true,
        },
        {
          label: "浇筑部位",
          width: "120",
          prop: "pouringPart",
          status: true,
        },
        {
          label: "站点",
          width: "120",
          prop: "station",
          status: true,
        },
        {
          label: "计划浇筑方式",
          width: "120",
          prop: "pouringMethod",
          status: true,
        },
        {
          label: "离场浇筑方式",
          width: "120",
          prop: "outPouringMethod",
          status: true,
        },
        {
          label: "产品名称",
          width: "120",
          prop: "product",
          status: true,
        },
        {
          label: "拒绝类型",
          width: "120",
          prop: "refuseType",
          status: true,
        },
        {
          label: "认可签收量",
          width: "120",
          prop: "acceptSignNum",
          status: true,
        },
        {
          label: "拒绝原因",
          width: "120",
          prop: "refuseReason",
          status: true,
        },
        {
          label: "前场余料标记",
          width: "120",
          prop: "isClout",
          status: true,
        },
        {
          label: "运输签收小票",
          width: "120",
          prop: "signTicketUrl",
          status: true,
        },
        {
          label: "生产时间",
          width: "120",
          prop: "proTime",
          status: true,
        },
      ],
      exceptionDetailData: [],
      stationList: [],
    };
  },
  async created() {
    this.tableParam = { ...this.tableParam, exceptionType: "", handlerStatus: "", carNo: "",excepDescription:"" };
    this.table = this.tableA;
    this.UserInfo = await getUserInfo();
    this.stationList = await getUserAutList(true);
    /* 获取浇筑方式 */
    this.pumpTypeList = [];
    /**泵送方式 */
    getDicType({
      code: "castingType",
    }).then(res => {
      res.data.items.map(v1 => (v1.type = 1));
      this.pumpTypeList = [...this.pumpTypeList, ...res.data.items];
    });
    /**非泵送方式 */
    getDicType({
      code: "pouringMethod",
    }).then(res => {
      res.data.items.map(v2 => (v2.type = 2));
      this.pumpTypeList = [...this.pumpTypeList, ...res.data.items];
    });
    //异常原因
    getDicType({
      code: "exceptionReason",
    }).then(res => {
      this.exceptionReasonList = res.data.items;
    });
    this.init();
  },
  methods: {
    lookExceptionDetail(row) {
      getBusinessDetail({ exceptionId: row.id }).then(res => {
        if (res.code == 1001) {
          this.exceptionDetailData = [];
          res.data.pouringMethod = res.data.pouringMethod ? JSON.parse(res.data.pouringMethod) : [];
          // res.data.outPouringMethod = res.data.outPouringMethod ? JSON.parse(res.data.outPouringMethod) : [];
          this.exceptionDetailData.push(res.data);
          this.exceptionDetailDig = true;
        }
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile1(index) {
      this.listFiles1.splice(index, 1);
    },
    deleteFile2(index) {
      this.listFiles2.splice(index, 1);
    },
    deleteFile3(index) {
      this.listFiles3.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess1(data) {
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        path: data.fileUrl,
      };
      this.listFiles1.push(item);
    },
    uplodeSuccess2(data) {
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        path: data.fileUrl,
      };
      this.listFiles2.push(item);
    },
    uplodeSuccess3(data) {
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        path: data.fileUrl,
      };
      this.listFiles3.push(item);
    },
    look2Fun(e) {
      this.addDialog = true;
      this.exceptionId = e.id;
      let _this = this;
      _this.low = e;
      handler_info({ exceptionId: this.exceptionId }).then(res => {
        if (res.data) {
          _this.formData = res.data;
          _this.formData.isFlag = _this.formData.isFlag != null ? _this.formData.isFlag : 1;
          _this.listFiles1 = this.formData.handlerImageUrl ? this.formData.handlerImageUrl.split(",") : [];
          if (e.handlerStatus == 1) {
            if (this.formData.reconditionUrl) {
              let img = this.formData.reconditionUrl.split(",")
              let imgList = img.map((item, index) => {
                return {
                  fileName: "工地重车过磅照片" + (index + 1),
                  fileUrl: item,
                  path: item,
                }
              })
              _this.listFiles2 = imgList
            } else {
              _this.listFiles2 = []
            }
            if (this.formData.emptyUrl) {
              let img = this.formData.emptyUrl.split(",")
              let imgList2 = img.map((item, index) => {
                return {
                  fileName: "工地空车过磅照片" + (index + 1),
                  fileUrl: item,
                  path: item,
                }
              })
              _this.listFiles3 = imgList2
            } else {
              _this.listFiles3 = []
            }

          } else {
            _this.listFiles2 = this.formData.reconditionUrl ? this.formData.reconditionUrl.split(",") : [];
            _this.listFiles3 = this.formData.emptyUrl ? this.formData.emptyUrl.split(",") : [];
          }


        } else {
          _this.formData = this.$options.data().formData;
          _this.listFiles1 = [];
          _this.listFiles2 = [];
          _this.listFiles3 = [];
          _this.formData.businessExceptionId = _this.exceptionId;
        }
        if (res.data.applyDets?.length > 0) {
          _this.formData.pouringMethodIds = res.data.applyDets.map(item => {
            return item.pouringWayId;
          });
          let name = res.data.applyDets.map(item => {
            return item.pouringWay;
          });
          _this.formData.pouringMethodName = name.join(",");
        } else {
          _this.formData.pouringMethodIds = [];
          _this.formData.pouringMethodName = "";
        }
        if (_this.formData.planPourMethod.length > 0) {
          let planPourMethod = JSON.parse(_this.formData.planPourMethod)
          let planPourMethodName = planPourMethod.map(item => item.name).join(', ');
          this.$set(_this.formData, 'planPourMethodName', planPourMethodName)
        }
        this.$refs.reffromDate.clearValidate();
      });
    },
    submit() {
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          let formData = JSON.parse(JSON.stringify(this.formData));
          if (this.listFiles1.length > 0) {
            let files1 = this.listFiles1.map(item => {
              return item.path;
            });
            formData.handlerImageUrl = files1.join(",");
          } else {
            formData.handlerImageUrl = "";
          }
          if (this.listFiles2.length > 0) {
            let files2 = this.listFiles2.map(item => {
              return item.path;
            });
            formData.reconditionUrl = files2.join(",");
          } else {
            formData.reconditionUrl = "";
          }
          if (this.listFiles3.length > 0) {
            let files3 = this.listFiles3.map(item => {
              return item.path;
            });
            formData.emptyUrl = files3.join(",");
          } else {
            formData.emptyUrl = "";
          }
          if (formData.pouringMethodIds?.length > 0) {
            let arr = [];
            formData.pouringMethodIds.forEach(item => {
              let sameType = false;
              formData.applyDets.forEach(item2 => {
                if (item == item2.pouringWayId) {
                  sameType = true;
                  arr.push(item2);
                }
              });
              if (!sameType) {
                this.pumpTypeList.forEach(item3 => {
                  if (item == item3.id) {
                    arr.push({
                      pouringWay: item3.itemName,
                      pouringWayId: item3.id,
                    });
                  }
                });
              }
            });
            formData.applyDets = arr;
          } else {
            formData.applyDets = [];
          }
          save_handler(formData).then(res => {
            if (res.code == 1001) {
              this.addDialog = false;
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.gettableData();
            }
          });
        }
      });
    },
    look1Fun(e) {
      this.look1Type = true;
      this.exceptionId = e.id;
      this.urlList = e.imageUrl ? e.imageUrl.split(",") : [];
      // attachment_list({ exceptionId: this.exceptionId }).then((res) => {
      //   this.urlList = res.data;
      // });
    },
    init() {
      /*重置数据*/
      // this.$data.tableParam = this.$options.data().tableParam;
      this.tableParam.handlerStatus = "";
      this.tableParam.exceptionType = "";
      this.tableParam.carNo = "";
      this.tableParam.excepDescription = "";
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.stationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.stationId = this.stationList[0].id;
      }
      this.gettableData();
    },
    choose(num) {
      this.currenindex = num;
      if (this.currenindex == 0) {
        this.table = this.tableA;
        this.tableParam.businessType = "type_front";
      } else {
        this.table = this.tableB;
        this.tableParam.businessType = "type_tank";
      }
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  filters: {
    imgMp4TypeFun(d) {
      if (d.includes("jpeg") || d.includes("jpg") || d.includes("png") || d.includes("webp")) {
        return "img";
      } else {
        return "mp4";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-pages {
  @include discen_al;
  padding-top: 10px;
}

.dialog-title {
  font-size: 16px;
  font-weight: bold;
  padding-right: 40px;
}

.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.tabtop {
  width: 381px;
}

.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
}
</style>
